import create from "zustand";
import { devtools } from "zustand/middleware"

import { Br_Report } from '../api/report.api'

const Report = (set, get) => ({
	BrReport_list: null,
	BrReport_down: null,
    getReportList: async (BranchCode) => {
		//set({ BranchStrength: "loading" })
		await Br_Report(BranchCode).then((r) => {
			if(r.data.response_code === '01'){
				set({ BrReport_list: r.data.ress })
			}else{
				set({ BrReport_list: null })
			}
		})
	},
	getReportDown: (BranchCode, SeqID) => {
		//set({ BranchStrength: "loading" })
		const data = Br_Report(BranchCode, SeqID)
		return data
	},

});

const ReportStore = create(Report);

export default ReportStore